// CompanySelect.jsx
import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";
import { getOffices, getOfficesByCompanyId } from "../../../api/officeService";

const OfficeSelect = ({ companyId = "", value, onChange, label = "Select Office", ...props }) => {
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOffices = async () => {
      try {
        if (companyId) {
            const response = await getOfficesByCompanyId(companyId);
            const sortedOffices = response.sort((a, b) =>
                a.name.localeCompare(b.name)
            );
            setOffices(sortedOffices);
        } else {
            const response = await getOffices();
            setOffices(response);
        }
        } catch (error) {
            console.error("Error fetching offices:", error);
        } finally {
            setLoading(false);
        }
    };

    fetchOffices();
  }, [companyId]);

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <Select value={value} onChange={onChange} label={label}>
          {offices.map((office) => (
            <MenuItem key={office.id} value={office.id}>
              {office.name}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default OfficeSelect;